import {memo} from 'react'
import useCountdown from '../../hook/useCountdown'

import { 
    TextS
} from '../../components';


function Countdown({end}) {
    const countdown = useCountdown(end)
    return (
        // <TextXL>{new Date(countdown.second).Format(countdown.format)}</TextXL>
        <TextS>{countdown}</TextS>
    )
}
const CountdownMemo = memo(Countdown)


export default CountdownMemo